import {
  Component,
  ViewContainerRef,
  OnInit,
  ViewChild,
  ElementRef,
  AfterContentChecked,
  OnChanges,
  SimpleChanges,
} from "@angular/core";
import { BsModalService } from "ngx-bootstrap/modal";
import { BsModalRef } from "ngx-bootstrap/modal";
import { AccountantService } from "../../accountant/accountant.service";
import { DashboardService } from "../../../dashboard.service";
import { EditAppsModalService } from "./edit-apps-modal.service";
import { MyAccountService } from "./my-account-modal.service";
import { LocalStorageService } from "src/app/utils/localstorage.service";
import {
  FormBuilder,
  FormGroup,
  FormControl,
  Validators,
} from "@angular/forms";
import { FormUtil } from "../../../../utils/formutils";
import moment from "moment";

import { HotToastService } from "@ngneat/hot-toast";
import * as _ from "underscore";

@Component({
    selector: "open-app-modal-component",
    templateUrl: "./open-app-modal.component.html",
    standalone: true,
})
export class OpenAppModalComponent implements OnInit, OnChanges {
  public app: any = { vault: {} };
  data: any = {};
  pin: any;
  expired: boolean;
  copied = "";

  @ViewChild("appInput") appInput: ElementRef;

  constructor(
    public bsModalRef: BsModalRef,
    private editAppsModalService: EditAppsModalService,
    private toastr: HotToastService,
    private myAccountService: MyAccountService,
    private localStorage: LocalStorageService,
    vcr: ViewContainerRef
  ) {}

  ngOnInit(): void {
    this.data = this.localStorage.get("data");

    let now = moment();

    if (now.isBefore(this.localStorage.get("pin_expires"))) {
      this.expired = false;
    } else {
      this.expired = true;
    }
  }

  public ngOnChanges(changes: SimpleChanges) {
    console.log(changes);
    this.app = changes.app;
  }

  openApp(): void {
    window.open(this.app.url, "_blank");
  }

  copiedField(type): void {
    this.toastr.success(type + " copied to clipboard.");
  }

  unlockPin(): void {
    this.myAccountService.check_pin(this.pin).then(
      (res) => {
        const response = res;
        this.localStorage.set(
          "pin_expires",
          moment().add(response.timeout, "minutes").toDate()
        );
        this.expired = false;
      },
      (err) => {
        this.toastr.error(err.error.message);
      }
    );
  }
}
